import Vue from 'vue';
import Vuex from 'vuex';

import Exam from './modules/Exam';
import Question from './modules/Question';
import Filter from './modules/Filter';

Vue.use(Vuex);

export const SET_GLOBAL_LOADING = 'SET_GLOBAL_LOADING';

export default new Vuex.Store({
  modules: {
    Exam,
    Question,
    Filter,
  },
  state: {
    isLoading: false,
    vertical: window.sessionStorage.getItem('vertical') || 'medicina',
  },
  getters: {
    isMedicina: state => state.vertical === 'medicina',
    isConcursos: state => state.vertical === 'concursos',
  },
  actions: {
    setGlobalLoading({ commit }, status) {
      commit(SET_GLOBAL_LOADING, status);
    },
  },
  mutations: {
    [SET_GLOBAL_LOADING]: (state, status) => {
      state.isLoading = status;
    },
  },
});
